import { Injectable } from '@angular/core';
import {ConnectionService} from "./connection.service";
import {Http, Headers, RequestOptions} from "@angular/http";
import {Resource} from "../entities/Resource";
import {Observable} from "rxjs/Observable";
import 'rxjs/add/operator/map'
import {AppConfig} from "../app.config";
import {RequestInterceptor} from "./Interceptors/RequestInterceptor";

@Injectable()
export class EmployeeService {

  private params: string;
  private feedback: string;
  private readonly apiUrl: string;

  private getHeaders(company = null): RequestOptions {
    const headers: Headers = this.connectionService.GetAuthorizationHeader(company);
    return new RequestOptions({ headers });
  }

  constructor(private http: Http,
              private connectionService: ConnectionService,
              private config : AppConfig,
              private requestInterceptor: RequestInterceptor) {
    this.apiUrl = config.getConfig('endPointApiUrl') + 'api/Resources/';
  }

  createUser(user: Resource): Observable<string> {
    this.params = JSON.stringify(user);

    return this.http
      .post(this.apiUrl + 'Users', this.params, this.getHeaders())
      .map((resp) => this.feedback = resp.json());
  }

  getAllUsers(): Observable<Resource[]> {
    return this.requestInterceptor
      .get(this.apiUrl, this.getHeaders())
      .map(response => response.json() as Resource[]);
  }

  getUser(id: number): Observable<Resource> {
    return this.requestInterceptor
      .get(this.apiUrl + 'Users/' + id, this.getHeaders())
      .map(response => response.json() as Resource);
  }

  putUser(user: Resource) {
    this.params = JSON.stringify(user);
    return this.http
      .put(this.apiUrl + 'Users/' + user.No, this.params, this.getHeaders())
      .subscribe(resp => {});
  }

  deleteUser(user: Resource) {
    return this.http
      .delete(this.apiUrl + 'Users/' + user.No, this.getHeaders())
      .subscribe(resp => {});
  }
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/services/employee.service.ts